import { type FC } from 'react';

import { useUserQuery } from '@/packages/query-state/shared/store/monolith-python/cian-api/site/v1/get-user-data-by-request/query';
import { useListingLayoutIsNarrowSelector } from '@/packages/redux-state/store/slices/listingLayout/selectors/dumb';

import { CardVASListContainer } from '../CardVASListContainer';
import { PublicationDateContainer } from '../PublicationDateContainer';

import { VASBlock } from './components/VASBlock';

export const CardVASBlockContainer: FC = () => {
  const { data: user } = useUserQuery();
  const isNarrow = useListingLayoutIsNarrowSelector();

  return (
    <VASBlock
      isAgentUser={!!user?.isAgent}
      isNarrow={isNarrow}
      publicationDate={<PublicationDateContainer />}
      vasList={<CardVASListContainer />}
    />
  );
};
